import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { PromotionProduct } from "../../api/Promotion"
import { addItemToCart } from "api/Cart"
import { API_URL } from "env"
import { useWishlist } from "hooks/useWishlist"
import { fetchViewedProducts } from "api/Viewed_product"
import BottomQualityControl from "providers/QualityControlComponent/BottomQualityControl"

interface Product {
    id: number
    slug: string
    name: string
    unit: string
    image: string
    price: number
    promoPrice?: number
    discount?: string
    sold: number
    seller: string
    sellerLogo: string
    quantity: number
    liked: boolean
    bg: boolean
}

interface ProductItemProps {
    data: Product;
    onMinus: () => void;
    onPlus: () => void;
}

interface ProductsListBgColorNoneP0Props {
    products?: PromotionProduct[]
    useViewedProducts?: boolean
}

export default function ProductsListBgColorNoneP0({ products, useViewedProducts = false }: ProductsListBgColorNoneP0Props) {
    const [list, setList] = useState<Product[]>([])

    useEffect(() => {
        if (products && products.length > 0) {
            setList(products.map(item => ({
                id: item.product?.id,
                slug: item.product?.slug,
                name: item.product?.name,
                unit: "Hộp",
                image: item.product?.avatar,
                price: item.product?.price * (1 - item.percent / 100),
                promoPrice: item.product?.price,
                discount: `-${item.percent}%`,
                sold: 0,
                seller: "Dược Tâm Hạnh",
                sellerLogo: "",
                quantity: 0,
                liked: false,
                bg: false,
            })))
            return;
        }

        if (!useViewedProducts) {
            setList([]);
            return;
        }

        const loadViewedProducts = async () => {
            const res = await fetchViewedProducts('created_at,desc', 10);
            if (!res?.status || !res.data?.items) {
                setList([]);
                return;
            }

            const mappedViewedProducts: Product[] = res.data.items
                .map((item) => {
                    const product = item.product;
                    const originalPrice = Number(product?.price) || 0;
                    const apiDiscountPrice = Number(product?.discount_price) || 0;
                    const promotionPercent = Number(product?.promotion?.percent) || 0;

                    const computedDiscountPrice = apiDiscountPrice > 0
                        ? apiDiscountPrice
                        : (promotionPercent > 0 ? Math.round(originalPrice * (1 - promotionPercent / 100)) : originalPrice);

                    const finalDiscountPrice = computedDiscountPrice > 0 && computedDiscountPrice < originalPrice
                        ? computedDiscountPrice
                        : originalPrice;

                    const finalDiscountPercent = originalPrice > 0 && finalDiscountPrice < originalPrice
                        ? Math.round((1 - finalDiscountPrice / originalPrice) * 100)
                        : 0;

                    return {
                        id: Number(product?.id) || 0,
                        slug: product?.slug || "#",
                        name: product?.name || "",
                        unit: product?.unit || "Hộp",
                        image: product?.avatar || "",
                        price: finalDiscountPrice,
                        promoPrice: finalDiscountPercent > 0 ? originalPrice : undefined,
                        discount: finalDiscountPercent > 0 ? `-${finalDiscountPercent}%` : undefined,
                        sold: 0,
                        seller: product?.product_category?.name || "Dược Tâm Hạnh",
                        sellerLogo: "",
                        quantity: 0,
                        liked: false,
                        bg: false,
                    };
                })
                .filter((item: Product) => item.id > 0);

            setList(mappedViewedProducts);
        };

        loadViewedProducts();
    }, [products, useViewedProducts])

    const updateQty = (id: number, delta: number): void => {
        if (!id) return;
        addItemToCart(id.toString(), delta > 0 ? 1 : -1);
        setList((prev: Product[]) =>
            prev.map((item: Product) =>
                item.id === id
                    ? {
                        ...item,
                        quantity: Math.max(0, Math.min(item.quantity + delta, 5)),
                    }
                    : item
            )
        )
    }



    return (
        <div className="MuiBox-root css-1vv0xgi mobile-padding-0">
            {list.map(item => (
                <ProductItem
                    key={item.id}
                    data={item}
                    onMinus={() => updateQty(item.id, -1)}
                    onPlus={() => updateQty(item.id, 1)}

                />
            ))}
        </div>
    )
}


function ProductItem({ data, onMinus, onPlus }: ProductItemProps) {
    const { handleToggleWishlist, isInWishlist } = useWishlist();

    const onLikeClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        handleToggleWishlist(data.id);
    };
    return (
        <div
            className={`styles_container__IDdis styles_container__ruVTs ${data.bg ? "t-bg-color" : "t-bg-white"}`}
            role="button"
            tabIndex={0}
        >
            {/* <div className="styles_nearExpiration__MruDA" style={{ color: "rgb(255, 64, 3)", backgroundColor: "rgb(255, 255, 255)" }}>Cận Date 31-03-2026</div> */}
            <div className="styles_tooltipRight__KgBN7" role="button">
                <div
                    className="styles_customButton__HNiJK"
                    title="Đánh dấu sản phẩm quan tâm"
                    onClick={onLikeClick}
                >
                    <svg style={{
                        fontSize: 24,
                        color: isInWishlist(data.id)
                            ? "rgb(234, 32, 43)"
                            : "rgba(0, 0, 0, 0.2)",
                    }} className="MuiSvgIcon-root styles_icon__Zwjan" focusable="false" viewBox="0 0 24 24" aria-hidden="true"><path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"></path></svg>
                </div>
            </div>

            {/* === TOP IMAGE (GIỮ NGUYÊN) === */}

            {/* ================= TOP IMAGE ================= */}
            <div className="styles_topContainer__8eSB4">
                <Link
                    className="styles_mobile_rootBase__8z7PQ styles_stylesImage__YoHx0"
                    to={`/product/${data.slug}`}
                >
                    <span
                        style={{
                            boxSizing: "border-box",
                            display: "inline-block",
                            overflow: "hidden",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0,
                            position: "relative",
                            maxWidth: "100%",
                        }}
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "block",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: 0,
                                margin: 0,
                                padding: 0,
                                maxWidth: "100%",
                            }}
                        >
                            <img
                                alt=""
                                aria-hidden="true"
                                src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27160%27%20height=%27160%27/%3e"
                                style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                }}
                            />
                        </span>

                        <img
                            alt={data.name}
                            src={`${data.image}?width=300&quality=80`}
                            decoding="async"
                            data-nimg="intrinsic"
                            className="styles_image__Y8Jva"
                            style={{
                                position: "absolute",
                                inset: 0,
                                boxSizing: "border-box",
                                padding: 0,
                                border: "none",
                                margin: "auto",
                                display: "block",
                                width: 0,
                                height: 0,
                                minWidth: "100%",
                                maxWidth: "100%",
                                minHeight: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                            }}
                        />
                        <noscript />
                    </span>
                </Link>

                {/* ================= TAG LIST ================= */}
                {/* <div className="styles_listTag__QSJO1">
                    <a
                        className="styles_mobile_rootBase__8z7PQ styles_tagContainer__sbEMn"
                        href="/tag/khan-hang"
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: "0px",
                                margin: "0px",
                                padding: "0px",
                                position: "relative",
                                maxWidth: "100%",
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "block",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: "0px",
                                    margin: "0px",
                                    padding: "0px",
                                    maxWidth: "100%",
                                }}
                            >
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2760%27%20height=%2730%27/%3e"
                                    style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                    }}
                                />
                            </span>

                            <img
                                alt="img"
                                data-origin-url="/theme/KHAN_HANG_Tag_Label_CARD_DOC.svg"
                                src="/theme/KHAN_HANG_Tag_Label_CARD_DOC.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                className="styles_image__Y8Jva"
                                style={{
                                    position: "absolute",
                                    inset: "0px",
                                    boxSizing: "border-box",
                                    padding: "0px",
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: "0px",
                                    height: "0px",
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                }}
                            />
                            <noscript />
                        </span>
                    </a>

                    <a
                        className="styles_mobile_rootBase__8z7PQ styles_tagContainer__sbEMn"
                        href="/deals"
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: "0px",
                                margin: "0px",
                                padding: "0px",
                                position: "relative",
                                maxWidth: "100%",
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "block",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: "0px",
                                    margin: "0px",
                                    padding: "0px",
                                    maxWidth: "100%",
                                }}
                            >
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2760%27%20height=%2730%27/%3e"
                                    style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                    }}
                                />
                            </span>

                            <img
                                alt="img"
                                data-origin-url="/theme/khuyenmai_1.svg"
                                src="/theme/khuyenmai_1.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                className="styles_image__Y8Jva"
                                style={{
                                    position: "absolute",
                                    inset: "0px",
                                    boxSizing: "border-box",
                                    padding: "0px",
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: "0px",
                                    height: "0px",
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                }}
                            />
                            <noscript />
                        </span>
                    </a>

                    <a
                        className="styles_mobile_rootBase__8z7PQ styles_tagContainer__sbEMn"
                        href="/products"
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: "0px",
                                margin: "0px",
                                padding: "0px",
                                position: "relative",
                                maxWidth: "100%",
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "block",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: "0px",
                                    margin: "0px",
                                    padding: "0px",
                                    maxWidth: "100%",
                                }}
                            >
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2760%27%20height=%2730%27/%3e"
                                    style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                    }}
                                />
                            </span>

                            <img
                                alt="img"
                                data-origin-url="/theme/limited_doc.svg"
                                src="/theme/limited_doc.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                className="styles_image__Y8Jva"
                                style={{
                                    position: "absolute",
                                    inset: "0px",
                                    boxSizing: "border-box",
                                    padding: "0px",
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: "0px",
                                    height: "0px",
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain",
                                }}
                            />
                            <noscript />
                        </span>
                    </a>
                </div> */}
            </div>

            {/* ================= UNDER CONTAINER ================= */}
            <div className="styles_underContainer__mL2nM">
                {/* PRICE */}
                <div className="styles_priceContainer__F_qQS px-[8px]">
                    <div className="styles_price__P5IMX" style={{ transform: "translateX(0px)" }}>
                        <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                            <div
                                className="styles_canvasPrice__vw932"
                                style={{ height: 25 }}
                            >{data.price.toLocaleString()} ₫</div>
                        </div>
                    </div>

                    {data.promoPrice && (
                        <div className="styles_pricePromo__JxTg_ ml-[8px]">
                            <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                <div
                                    className="styles_canvasPrice__vw932 text-[12px]"
                                    style={{ height: 15, textDecoration: "line-through" }}
                                >{data.promoPrice.toLocaleString()} ₫</div>
                            </div>
                        </div>
                    )}
                </div>

                {/* TITLE */}
                <div className="styles_titleContainer__WYihl">
                    <Link
                        className="styles_titleWrapper__FvOnI"
                        to={`/product/${data.slug}`}
                    >
                        <span>{data.name}</span>
                    </Link>
                    <p className="MuiTypography-root styles_countPerItem__OvDsy MuiTypography-body1">
                        {data.unit}
                    </p>
                </div>

                {/* SELLER */}
                {/* <div className="styles_wrapperTooltip__MHPzJ" title="MEDX">
                    <div className="styles_wrapperImage__VTK_J">
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: "0px",
                                margin: "0px",
                                padding: "0px",
                                position: "relative",
                                maxWidth: "100%",
                            }}
                        >
                            <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "block",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: "0px",
                                    margin: "0px",
                                    padding: "0px",
                                    maxWidth: "100%",
                                }}
                            >
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2714%27%20height=%2716%27/%3e"
                                    style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: "0px",
                                        margin: "0px",
                                        padding: "0px",
                                    }}
                                />
                            </span>

                            <img
                                alt="MEDX"
                                data-origin-url="https://cdn-web-next.thuocsi.vn/icons/color_seller.svg"
                                src="https://cdn-web-next.thuocsi.vn/icons/color_seller.svg"
                                decoding="async"
                                data-nimg="intrinsic"
                                style={{
                                    position: "absolute",
                                    inset: "0px",
                                    boxSizing: "border-box",
                                    padding: "0px",
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: "0px",
                                    height: "0px",
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                }}
                            />
                            <noscript />
                        </span>
                    </div>

                    <a
                        className="styles_mobile_rootBase__8z7PQ styles_link__jjTWc"
                        target="_blank"
                        href="/seller-products/cong-ty-tnhh-duoc-pham-medx"
                    >
                        MEDX
                    </a>
                </div> */}

                {/* PROGRESS */}
                <div className="styles_progressContainer__JrGkW">
                    <div className="styles_progressBuy__hItNv">
                        <div
                            className="MuiLinearProgress-root MuiLinearProgress-colorPrimary css-1hyif4h MuiLinearProgress-determinate"
                            role="progressbar"
                            aria-valuenow={16}
                            aria-valuemin={0}
                            aria-valuemax={100}
                        >
                            <div
                                className="MuiLinearProgress-bar MuiLinearProgress-barColorPrimary MuiLinearProgress-bar1Determinate"
                                style={{ transform: "translateX(-84%)" }}
                            />
                        </div>
                        <p className="MuiTypography-root styles_buyCount__qtYPa MuiTypography-body1">
                            Đã bán {data.sold}
                        </p>
                    </div>

                    <span className="styles_limitMessage__Iq3IG">
                        Đặt tối đa 5 sản phẩm
                    </span>
                </div>

                <div className="styles_controlQuantity__QWHZr" />
            </div>

            {/* === QUANTITY CONTROL === */}
            <BottomQualityControl productId={data.id} productName={data.name} />
        </div>
    )
}

